import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/notice',
        name: 'Notice',
        component: () => import('../views/Notice.vue')
    },
    {
        path: '/end',
        name: 'End',
        component: () => import('../views/End.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
